import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import styled from 'styled-components'
import styleguide from 'styleguide'

import { IconDown } from 'blocket-ui'

export const getBorderStyle = (position) => {
  switch (position) {
    case 'left':
      return `border-top-right-radius: 0;
border-bottom-right-radius: 0;`
    case 'right':
      return `border-top-left-radius: 0;
border-bottom-left-radius: 0;
border-left: none;`
    default:
      return ''
  }
}

const Wrapper = styled.label`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: transparent;
  font-size: 15px;
  /* Removes a 1px padding in IOS safari */
  box-sizing: border-box;

  ${(props) =>
    props.size === 'tiny'
      ? ''
      : `padding: ${styleguide.padding.medium}px ${styleguide.padding.medium}px;
    border: solid 1px ${styleguide.color.gray15};
    border-radius: 3px;
    background-color: ${styleguide.color.white};
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 0;
    ${getBorderStyle(props.position)}`}
`

export const Select = styled.select`
  outline: none;
  position: absolute;
  width: 100%;
  height: 100%;

  /* The fontSize needs to be set to something large here to stop iOS from zooming in on the select element. */
  font-size: 16px;
  opacity: 0;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`

const LabelText = styled.div`
  margin-right: 0.5em;
  color: #363433;
`

const SelectDropdown = ({ id, value, options, handleChange, labelText, position, size }) => {
  const currentOption = _.find(options, { value })
  const currentLabel = (currentOption && currentOption.label) || options[0].label

  return (
    <Wrapper htmlFor={id} position={position} size={size}>
      <Select id={id} value={value} onChange={handleChange}>
        {options.map((option) => (
          <option key={option.value} value={option.value} disabled={option.disabled}>
            {option.label}
          </option>
        ))}
      </Select>
      <LabelText>
        {labelText}{' '}
        <span style={{ color: size === 'tiny' ? styleguide.color.blue : styleguide.color.gray67 }}>
          {currentLabel}
        </span>
      </LabelText>
      <IconDown width={14} height={14} color={styleguide.color.black} />
    </Wrapper>
  )
}

SelectDropdown.defaultProps = {
  labelText: null,
}

SelectDropdown.propTypes = {
  value: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  id: PropTypes.string,
  position: PropTypes.string,
  size: PropTypes.string,
}

export default SelectDropdown
